import { s } from "../style.js";
import type { Task } from "../types";

// Ink-field / outline / tint status pill driven by the STATUS ladder in data.js.
export default function StatusPill({ task }: { task: Task }) {
  return (
    <span
      style={{
        ...s(
          "display:inline-flex; align-items:center; gap:8px; padding:5px 11px; font-size:15px; letter-spacing:0.08em; text-transform:uppercase; font-family:var(--font-heading); font-weight:800"
        ),
        background: task.statusBg,
        color: task.statusInk,
        border: task.statusBorder,
      }}
    >
       <span style={{ ...s("width:10px; height:10px; flex:none"), background: task.statusDot }} />
       {task.status}
    </span>
  );
}
